import { request } from './http';

export async function generateEnvironmentalSamplingRecords() {
    return request('/scheduler/generate-environmental-sampling-records', {
      method: 'POST'
    });
  }

export async function getMissedComplianceRecords(daysBack = 30) {
    return request(`/scheduler/missed-compliance-records?daysBack=${daysBack}`);
  }

export async function generateMissedComplianceRecords(options = {}) {
    const {
      recordIds = null,
      maxDaysBack = 30,
      updateOriginals = true
    } = options || {};

    return request('/scheduler/generate-missed-compliance-records', {
      method: 'POST',
      body: JSON.stringify({
        recordIds,
        maxDaysBack,
        updateOriginals
      })
    });
  }

export async function getMissedRecordsSummary(daysBack = 90) {
    return request(`/scheduler/missed-records-summary?daysBack=${daysBack}`);
  }

export async function getSchedulerJobRecords(executionId) {
    return request(`/scheduler/jobs/${executionId}/records`);
  }

export async function getSchedulerTimeConfig() {
    return request('/scheduler/time-config');
  }

export async function updateSchedulerTimeConfig(timeConfig) {
    return request('/scheduler/time-config', {
      method: 'POST',
      body: JSON.stringify(timeConfig)
    });
  }

export const schedulerMissedRecordsGenerationApi = {
  generateEnvironmentalSamplingRecords,
  getMissedComplianceRecords,
  generateMissedComplianceRecords,
  getMissedRecordsSummary,
  getSchedulerJobRecords,
  getSchedulerTimeConfig,
  updateSchedulerTimeConfig,
};

